import { DocumentInformationViewModel } from "src/app/view-models/document-information.view-model";
import { StoredDocumentInformation } from "../models/stored-document-information";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between DocumentInformation view model and database StoredDocumentInformation.
 */
export class DocumentInformationMapper implements IStoredMapper<DocumentInformationViewModel, StoredDocumentInformation> {
	/**
	 * Maps a DocumentInformationViewModel to a StoredDocumentInformation.
	 * @param documentInformation The document information data to convert.
	 * @returns A StoredDocumentInformation object.
	 */
	public ToStored(documentInformation: DocumentInformationViewModel): StoredDocumentInformation {
		return {
			LegacyId: documentInformation.LegacyId,
			Page: documentInformation.Page,
			FileName: documentInformation.FileName
		};
	}

	/**
	 * Maps a StoredDocumentInformation to a DocumentInformationViewModel.
	 * @param storedDocumentInformation The stored document information number data to convert.
	 * @returns A DocumentInformation object.
	 */
	public FromStored(storedDocumentInformation: StoredDocumentInformation): DocumentInformationViewModel {
		return {
			LegacyId: storedDocumentInformation.LegacyId,
			Page: storedDocumentInformation.Page,
			FileName: storedDocumentInformation.FileName
		};
	}
}